import React from 'react';
import {Item} from "components/Form/MultiSelector/MultiSelector";
import AccessibilityCriterion from "types/AccessibilityCriterion";
import {toTitleCase} from "services/string";
import MultiSelector from "components/Form/MultiSelector";
import IconName from "types/IconName";

type Props = {
    label?: string
    selectedIds?: Array<number | string>
    onChange: (criteria?: Array<AccessibilityCriterion>) => any
}

const criterionDescriptions: Record<AccessibilityCriterion, string> = {
    [AccessibilityCriterion.ASSISTANCE_DOGS_PERMITTED]: 'Assistance dogs are allowed here',
    [AccessibilityCriterion.BRIGHT_LIGHTING]: 'This is a brightly lit area',
    [AccessibilityCriterion.CROWDED]: 'This is likely to be a crowded area',
    [AccessibilityCriterion.HEADPHONE_AREA]: 'Headphones are used in this area',
    [AccessibilityCriterion.INTERACTIVE]: 'There are interactive experiences in this area',
    [AccessibilityCriterion.LEVEL_TERRAIN]: 'The ground is firm and level',
    [AccessibilityCriterion.LOW_LIGHTING]: 'This is a dimly lit area',
    [AccessibilityCriterion.NOISY]: 'This is likely to be a noisy area',
    [AccessibilityCriterion.PUSHCHAIR_ACCESSIBLE]: 'This location is suitable for pushchairs',
    [AccessibilityCriterion.QUIET]: 'This is likely to be a quiet area',
    [AccessibilityCriterion.REMOTE]: 'This is a location that is far away from the entrance, exit or amenities',
    [AccessibilityCriterion.ROUGH_TERRAIN]: 'The ground is rough and can be difficult to traverse',
    [AccessibilityCriterion.STEEP_TERRAIN]: 'There is a steep incline or decline here',
    [AccessibilityCriterion.SMELLY]: 'There are strong smells here',
    [AccessibilityCriterion.STEPS]: 'There are steps to climb here',
    [AccessibilityCriterion.UNEVEN_TERRAIN]: 'The ground is uneven or soft',
    [AccessibilityCriterion.WHEELCHAIR_ACCESSIBLE]: 'This location is suitable for wheelchairs',
}


const items: Array<Item> = Object.values(AccessibilityCriterion).map(id => ({
    id,
    name: toTitleCase(id),
    description: criterionDescriptions[id],
    icon: IconName.HAND
}))

function AccessibilitySelector({label, selectedIds, onChange}: Props) {
    return (
        <MultiSelector
            label={label ?? "Accessibility"}
            selectedIds={selectedIds}
            items={items}
            onChange={selectedItems =>
                onChange(selectedItems?.map(value => value.id as AccessibilityCriterion) || [])
            }
        />
    );
}

export default AccessibilitySelector;